import React from 'react';
import { UserProfile } from 'fitbeat.gym-core';
import { StyleSheet, Text, TouchableOpacity, View, ViewStyle } from 'react-native';
import { Icon } from '../../components';
import FontAwesomeIcon from 'react-native-vector-icons/FontAwesome';
import Theme from '../../theme';
import { showMessage } from './Toast';
import { Share } from '../../utils';
import moment from 'moment';
import { GymResolver } from '../../services';

interface IProps {
  userProfile: UserProfile,
  link: string | null;
  t(key: string, options?: any): string;
  onShare?(): void;
}

export const InvitePlatformStrip = ({ t, link, userProfile, onShare }: IProps) => (
  <TouchableOpacity
    onPress={async () => {
      const personalisedHeader = GymResolver.getPersonalisedHeader(userProfile.gymName);
      const result = await Share.share({
        message: t('home:openInviteUser', {
          link,
          fullname: userProfile.fullname.toUpperCase(),
          interpolation: { escapeValue: false },
          date: moment(new Date()).format('DD MMM YYYY HH:MM'),
          personalisedHeader,
        }),
        title: t('home:inviteUserToJoinFitillion', { personalisedHeader }),
      });

      if (result.action === Share.sharedAction) {
        if (onShare) {
          onShare();
        }
        showMessage(t('home:inviteHasBeenSent'));
      }
    }}
    style={styles.container}>
    <InviteIcon first icon='whatsapp' IconFamily={FontAwesomeIcon} style={{ marginTop: -2 }} />
    <InviteIcon icon='md-text' size={28} style={{ marginTop: 3 }}/>
    <InviteIcon icon='md-mail' />
    <InviteIcon icon='ios-link' />
    <View style={[styles.inviteIconContainer, styles.last]}>
      <Text style={styles.elipsis}>...</Text>
    </View>
  </TouchableOpacity>
);

interface IPlatformProps {
  icon: string;
  IconFamily?: any,
  first?: boolean;
  style?: ViewStyle;
  size?: number;
}

const InviteIcon = ({ icon, first, IconFamily = Icon, style, size = 25}: IPlatformProps) => (
  <View style={[styles.inviteIconContainer, first && styles.first]}>
    <IconFamily name={icon} size={size} color={Theme.WHITE} style={style} />
  </View>
)

const styles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    justifyContent: 'center'
  },
  inviteIconContainer: {
    width: 40,
    height: 35,
    marginRight: 2,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: Theme.PRIMARY,
    paddingTop: 2,
  },
  first: {
    borderTopLeftRadius: 6,
    borderBottomLeftRadius: 6,
  },
  last: {
    marginRight: 0,
    borderTopRightRadius: 6,
    borderBottomRightRadius: 6,
  },
  elipsis: {
    fontSize: 40,
    lineHeight: 40,
    marginTop: -21,
    color: Theme.CHARCOAL,
  }
});
